import { AfterViewInit, Component, computed, effect, ViewChild } from '@angular/core';
import { IonicModule, IonInput, ModalController, Platform } from '@ionic/angular';
import { UnitsHelper } from 'app/services/units.helper';
import { ICan } from 'app/models/can';

import { Store } from '@ngrx/store';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import * as dateHelper from 'app/helpers/date.helpers';
import * as fromCan from 'app/state/can';

import * as fromLoation from 'app/state/location/reducer';
import { BarcodeScannerComponent } from "app/components/barcode-scanner/barcode-scanner.component";
import * as fromBeverage from 'app/state/beverage';
import { ToastService } from '../../../../../../services/toast.service';
import * as fromBottle from 'app/state/bottle';


@Component({
  selector: 'app-edit-can',
  templateUrl: './edit-can.component.html',
  styleUrls: ['./edit-can.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    BarcodeScannerComponent
],
})
export class EditCanComponent implements AfterViewInit {
  @ViewChild('count') countInput: IonInput | undefined;

  locations = this.store.selectSignal(fromLoation.selectAllItems);
  item = this.store.selectSignal(fromCan.selectCurrentItem);
  ean = this.store.selectSignal(fromCan.selectEan);
  cans = this.store.selectSignal(fromCan.selectAllItems);
  bottles = this.store.selectSignal(fromBottle.selectAllItems);
  beverages = this.store.selectSignal(fromBeverage.selectAllItems);

  filledDate: string | null = null;
  bestBeforeDate: string | null = null;
  notificationDate: string | null = null;

  form = this.fb.group({
    count: ['', { validators: [Validators.required] }],
    location: ['',],
    selectCan: [''],
    uniqueId: [''],
    notificationMessage: ['']
  });

  constructor(
    private store: Store,
    private toastService: ToastService,
    private modalController: ModalController,
    public unitHelper: UnitsHelper,
    private fb: FormBuilder,
  ) {



    effect(() => {
      const internalItem = this.item();
      if (internalItem) {
        this.bestBeforeDate = dateHelper.getISOString(internalItem.bestBeforeDate as any);
        this.notificationDate = dateHelper.getISOString(internalItem.notificationDate as any);
        this.filledDate = dateHelper.getISOString(internalItem.filledDate as any);

        this.form.controls.notificationMessage.patchValue(internalItem.notificationMessage ?? '');

        const currentEan = this.ean();
        if (currentEan) {
          this.form.controls.uniqueId.patchValue(currentEan);
        } else {
          this.form.controls.uniqueId.patchValue(internalItem.uniqueId ?? '');
        }

        if (internalItem.count) {
          this.form.controls.count.patchValue(internalItem.count.toString());
        }

        if (!!internalItem.locationId) {
          this.form.controls.location.patchValue(internalItem.locationId.toString());
        }
      } else {
        const currentEan = this.ean();
        if (currentEan) {
          this.form.controls.uniqueId.patchValue(currentEan);
        }

      }
    });
  }

  ngAfterViewInit() {
    setTimeout(async () => {
      await this.countInput?.setFocus();
      await this.countInput?.getInputElement().then(input => input.select());
    }, 300);
  }

  closeModal() {
    this.store.dispatch(fromCan.setItem({ id: '' }));
    this.modalController.dismiss({
      dismissed: true
    });
  }

  dismiss() {
    if (this.form.invalid) {
      return;
    }

    const updatedItem = {
      ...this.item(),
      bestBeforeDate: this.bestBeforeDate ? this.bestBeforeDate : null,
      filledDate: this.filledDate ?? null,
      notificationDate: this.notificationDate ?? null,
      notificationMessage: this.form.controls.notificationMessage.value ?? '',
      locationId: this.form.controls.location.value ?? undefined,
      count: this.form.controls.count.value ? parseInt(this.form.controls.count.value, 10) : 0,
      uniqueId: this.form.controls.uniqueId.value == null ? undefined : this.form.controls.uniqueId.value
    } as ICan;

    this.store.dispatch(fromCan.updateItem({ item: updatedItem }));
    this.store.dispatch(fromCan.setItem({ id: '' }));

    this.modalController.dismiss({
      dismissed: true
    });
  }

  clearItem() {
    this.filledDate = null;
    this.bestBeforeDate = null;
    this.notificationDate = null;
  }

  async handleBarcodeScanned(barCode: string) {
    const can = this.cans().find(c => c.uniqueId === barCode);
    const bottle = this.bottles().find(b => b.uniqueId === barCode);

    if (can || bottle) {
      const beverage = this.beverages().find(bev => bev.id === (can?.beverageId ?? bottle?.beverageId));
      if (can && beverage) {
        this.store.dispatch(fromCan.deleteItem({ id: this.item()?.id ?? '' }));
        this.store.dispatch(fromBeverage.setItemAndNavigate({ id: beverage.id ?? '' }));
        this.store.dispatch(fromCan.setItem({ id: can.id ?? '' }));
        await this.countInput?.setFocus();
        await this.countInput?.getInputElement().then(input => input.select());
        this.toastService.warning(`Redirected to ${beverage.name}, and opende can edit screen, update the inventory number.`, 10000);
      } else if (bottle && beverage) {
        this.store.dispatch(fromCan.deleteItem({ id: this.item()?.id ?? '' }));
        this.store.dispatch(fromBeverage.setItemAndNavigate({ id: beverage.id ?? '' }));
        this.toastService.errorWithTimer(`Redirected to ${beverage.name}, barcode exists in BOTTLES.`, 10000);
        this.closeModal();
      }
    } else {
      this.form.controls.uniqueId.patchValue(barCode);
    }
  }


  //#region Date Functions
  //#region Filled Date
  setDefaultFilledDate() {
    this.filledDate = dateHelper.toISOString();
  }
  setFilledDate(event: any) {
    const value = event.detail.value;
    if (value) {
      this.filledDate = value;
    }
  }
  deleteFilledDate() {
    this.filledDate = null;
  }
  //#region Filled Date

  //#region Best Before Date
  setDefaultBestBeforeDate() {
    this.bestBeforeDate = dateHelper.toISOString();
  }
  setBestBeforeDate(event: any) {
    const value = event.detail.value;
    if (value) {
      this.bestBeforeDate = value;
    }
  }
  deleteBestBeforeDate() {
    this.bestBeforeDate = null;
  }
  //#region Best Before Date

  //#region Notification Date
  setDefaultNotificationDate() {
    this.notificationDate = dateHelper.toISOString();
  }
  setNotificationDate(event: any) {
    const value = event.detail.value;
    if (value) {
      this.notificationDate = value;
    }
  }
  deleteNotificationDate() {
    this.notificationDate = null;
  }
  //#region Best Before Date
  //#endregion Date Functons

}
